<main class="w-full px-4 lg:px-6 xl:px-8 py-4 sm:py-6 lg:py-8 overflow-hidden font-bold category-card">
  <!-- Desktop View -->
  <section class="hidden md:flex flex-col gap-5 items-start my-0 w-full">
    <!-- Toggle Header -->
    <header class="flex gap-1.5 items-center p-1.5 rounded-xl bg-blue-100/60">
      <!-- <button
        type="button"
        class="cursor-pointer px-4 py-2 text-base font-bold rounded-lg transition-all"
        [ngClass]="{
          'bg-blue-600 text-white shadow-sm': selectedCategory === 'used',
          'bg-transparent text-gray-700 hover:text-black': selectedCategory !== 'used'
        }"
        (click)="onCategorySelect('used')"
      >
        Used Part
      </button> -->
      <button type="button" class="cursor-pointer px-4 py-2 text-base font-bold rounded-lg transition-all" [ngClass]="{
          'bg-blue-600 text-white shadow-sm': selectedCategory === 'scrap',
          'bg-transparent text-gray-700 hover:text-black': selectedCategory !== 'scrap'
        }" (click)="onCategorySelect('scrap')">
        Scrap
      </button>
    </header>

    <!-- Category Cards -->
    <div class="w-full overflow-x-hidden scrollbar-hide">
      <div class="grid gap-4 md:gap-5 lg:gap-6 w-full cat-item animate-item" [ngClass]="{
          'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4':
            selectedCategory === 'used',
          'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6':
            selectedCategory === 'scrap',
        }">
        <ng-container *ngIf="selectedCategory === 'scrap'">
          <div *ngFor="let category of scrapList; trackBy: trackByCategory"
            (click)="gotoProductlist(category, 'Scrap Part')"
            class="group flex flex-col w-full min-w-0 cursor-pointer cat-item animate-item">
            <div class="w-full aspect-[3/2] overflow-hidden rounded-xl bg-gray-100 shadow-sm transition-all duration-300 group-hover:shadow-md">
              <img [src]="
                  category?.scrap_image_path
                    ? environment1 + category.scrap_image_path
                    : environment1 +
                      '/bookonline-parts-tatamotors-com-circularity/circularity/circularity/Category%20Part/8330.webp'
                " [alt]="category.altText || category.name" role="img"
                [attr.aria-label]="category.altText || category.name"
                class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" (error)="onImageError($event)" />
            </div>
            <div class="w-full text-left font-bold text-sm sm:text-base text-gray-900 truncate pt-2">
              {{ category.name }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedCategory === 'used'">
          <div *ngFor="let category of usedList; trackBy: trackByCategory"
            (click)="gotoProductlist(category, 'Used Part')"
            class="group flex flex-col w-full min-w-0 cursor-pointer cat-item animate-item">
            <div class="w-full aspect-[3/2] overflow-hidden rounded-xl bg-gray-100 shadow-sm transition-all duration-300 group-hover:shadow-md">
              <img [src]="
                  category?.scrap_image_path
                    ? environment1 + category?.scrap_image_path
                    : environment1 +
                      '/bookonline-parts-tatamotors-com-circularity/circularity/circularity/Category%20Part/8330.webp'
                " [alt]="category.altText || category.name" role="img"
                [attr.aria-label]="category.altText || category.name"
                class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" (error)="onImageError($event)" />
            </div>
            <div class="w-full text-left font-bold text-sm sm:text-base text-gray-900 truncate pt-2">
              {{ category.name }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </section>

  <!-- Mobile View -->
  <section class="flex md:hidden flex-col gap-3 sm:gap-5 items-center w-full">
    <!-- Toggle Buttons -->
    <section
      class="flex gap-1 justify-center items-center p-1 w-full text-sm leading-none rounded-lg bg-blue-200 bg-opacity-50 max-w-full">
      <!-- <button type="button" class="flex-1 shrink gap-1 self-stretch px-1 py-1.5 my-auto rounded basis-0 min-h-[30px]"
        [class.text-white]="selectedCategory === 'used'" [class.bg-blue-600]="selectedCategory === 'used'"
        [class.text-black]="selectedCategory !== 'used'" (click)="selectTab('used')">
        Used Part -->
      <!-- </button> -->
      <button type="button"
        class="flex-1 shrink gap-1 self-stretch px-1 py-1.5 my-auto whitespace-nowrap rounded basis-0 min-h-[30px]"
        [class.text-white]="selectedCategory === 'scrap'" [class.bg-blue-600]="selectedCategory === 'scrap'"
        [class.text-black]="selectedCategory !== 'scrap'" (click)="selectTab('scrap')">
        Scrap
      </button>
    </section>

    <!-- Category Items Scrollable -->
    <section class="flex flex-col gap-3 sm:gap-5 items-start mt-2 sm:mt-5 w-full text-xs text-black">
      <div class="w-full">
        <div class="flex overflow-x-auto gap-3.5 w-full pb-2">
          <ng-container *ngIf="selectedCategory === 'scrap'">
            <div *ngFor="let category of scrapList; trackBy: trackByCategory" class="flex-shrink-0 category-card-anim">
              <div (click)="gotoProductlist(category, 'Scrap Part')"
                class="flex flex-col w-[130px] min-w-[120px] max-w-[140px] cursor-pointer group">
                <div class="w-full aspect-[3/2] overflow-hidden rounded-xl bg-gray-100 shadow-sm">
                  <img [src]="
                      category?.scrap_image_path
                        ? environment1 + category.scrap_image_path
                        : environment1 +
                          '/bookonline-parts-tatamotors-com-circularity/circularity/circularity/Category%20Part/8330.webp'
                    " class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" alt="{{ category.name }}"
                    (error)="onImageError($event)" />
                </div>
                <p class="w-full text-left font-bold text-xs text-gray-900 truncate pt-2">
                  {{ category.name }}
                </p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="selectedCategory === 'used'">
            <div *ngFor="let category of usedList; trackBy: trackByCategory" class="flex-shrink-0">
              <div (click)="gotoProductlist(category, 'Used Part')"
                class="flex flex-col w-[130px] min-w-[120px] max-w-[140px] cursor-pointer group">
                <div class="w-full aspect-[3/2] overflow-hidden rounded-xl bg-gray-100 shadow-sm">
                  <img [src]="
                      category?.scrap_image_path
                        ? environment1 + category?.scrap_image_path
                        : environment1 +
                          '/bookonline-parts-tatamotors-com-circularity/circularity/circularity/Category%20Part/8330.webp'
                    " class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" alt="{{ category.name }}"
                    (error)="onImageError($event)" />
                </div>
                <p class="w-full text-left font-bold text-xs text-gray-900 truncate pt-2">
                  {{ category.name }}
                </p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
  </section>
</main>